import {styled} from '../../styled-components';
import {ZIndex} from '../../enums/z-index';

export const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${ZIndex.Modal};
`;

ModalWrapper.displayName = 'ModalWrapper';
